import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=bd412df2&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=bd412df2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd412df2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd412df2')) {
      api.createRecord('bd412df2', component.options)
    } else {
      api.reload('bd412df2', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=bd412df2&scoped=true&", function () {
      api.rerender('bd412df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KJWGh1HSeM9D/JS/comp/PopupDialog.vue"
export default component.exports